module.exports = __webpack_public_path__ + "static/tokr-webCBD-f0ef035f9274befbc5c5ce380f58ebf1.jpg";